import * as _ from 'lodash';
import * as api from '../../../api/api.service';
import * as featuresApi from '../../../api/features.service';
import { GroupAppEvent } from '../../../api/organizationGroups.service';

class GroupNotificationsController {
  account;
  notifications: GroupAppEvent[];
  enabled: boolean;
  loadAccount;
  loadFeatures;
  featureList: featuresApi.FeatureFlags;
  subNavApi;

  constructor(
    private api: api.IApiService,
    private LoadingIndicator,
    private $q,
    public LayoutService,
    private $route
  ) {
    'ngInject';
  }

  $onInit() {
    this.subNavApi = this.LayoutService.subNavApi;
    this.loadAccount = this.api.users.currentUser();
    this.loadFeatures = this.api.features.getFeatures();

    this.subNavApi.isSubNavVisible = () => {
      let featureList = (this.featureList as any) || {};
      let routeName = _.get(this, '$route.current.name'); // prevent from displaying in old route
      return routeName === 'notifications';
    };

    this.subNavApi.isLeader = () => {
      let account = (this.account as any) || {};
      return account.isLeader;
    };

    this.subNavApi.getSystemsDownloadUrl = () => {
      return this.systemsDownloadUrl;
    };

    this.loadFeatures.then((featureList) => {
      this.featureList = featureList;
    });

    this.loadAccount.then((account) => {
      this.account = account;
    });

    this.loadGroupDetails();
  }

  get systemsDownloadUrl(): string {
    let account = (this.account as any) || {};
    let organizationDetails = (this.groupId as any) || {};
    let featureList = (this.featureList as any) || {};
    let userType = account.isBuyer ? 'buyer' : 'seller';
    return `/aptitude/${userType}/BuyerProfileServiceController/downloadSystems?orgId=${this.groupId}`;
  }

  get isToolbarVisible() {
    let routeName = _.get(this, '$route.current.name'); // prevent from displaying in old route
    return routeName === 'notifications';
  }

  get groupId() {
    let featureList = (this.featureList as any) || {};
    let account = (this.account as any) || {};
    // we're assuming that the logged in user is a group leader
    return _.get(account.organization, 'id');
  }

  loadGroupDetails() {
    // Make sure acccount is loaded first
    this.$q
      .all([this.loadAccount, this.loadFeatures])
      .then((account, features) => {
        let getNotifications = this.api.organizationGroups.getGroupNotifications(
          this.groupId
        );

        this.LoadingIndicator.waitFor(getNotifications);

        getNotifications.then((notifications) => {
          this.notifications = notifications;
        });
      });
  }

  toggleNotificationCheckbox(notificationName: string, isSet: boolean) {
    let update = this.api.organizations.setGroupNotification(
      this.groupId,
      notificationName,
      isSet
    );

    this.LoadingIndicator.waitFor(update);
  }

  addAll() {
    _.each(this.notifications, (item) => {
      if (!item.subscribed) {
        item.subscribed = true;
        let update = this.api.organizations.setGroupNotification(
          this.groupId,
          item.appEvent.name,
          item.subscribed
        );

        this.LoadingIndicator.waitFor(update);
      }
    });
  }

  removeAll() {
    _.each(this.notifications, (item) => {
      if (item.subscribed) {
        item.subscribed = false;
        let update = this.api.organizations.setGroupNotification(
          this.groupId,
          item.appEvent.name,
          item.subscribed
        );

        this.LoadingIndicator.waitFor(update);
      }
    });
  }
}

export const GroupNotificationsComponent = {
  bindings: {
    enabled: '<'
  },
  template: require('./groupNotifications.component.html'),
  controller: GroupNotificationsController
};
